export default {"src":"/_next/static/media/empty-favorite-light.f6e19406.svg","height":100,"width":100};